import { gql, useQuery } from "@apollo/client";
export const updateDocumentItemsRemove = gql`
	mutation updateDocumentItemsRemove($id:String!,$documentId:String!){
	updateDocumentItemsRemove(id:$id,documentId:$documentId)
	}
`;
